<template>
  <el-main>
    <div class="container">
      <el-breadcrumb separator="/" class="common-nav">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/user/course' }">我的课程</el-breadcrumb-item>
        <el-breadcrumb-item>{{ video.title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="video-box" v-loading="loading">
            <video-player class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions" v-if="video" @play="playVideo">
            </video-player>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="videos">
            <div class="video-list" v-if="video.videos">
              <el-collapse v-model="activeNames" @change="handleChange">
                <el-collapse-item :title="item.title" :name="index" v-for="(item, index) in chapters" :key="index">
                  <div class="video-item" v-for="(videoItem, videoIndex) in item.video_classes" :key="videoIndex"
                       @click="changeVideo(videoIndex, index)"
                       :class="[videoActive === videoItem.id ? 'current' : '']">
                    <div class="video-item-title">
                      {{ videoItem.title }}
                    </div>
                    <div class="video-click" v-if="videoItem.logs.length > 0">
                      {{ videoItem.logs.length }}
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-main>
</template>

<script>
import {authRequest} from "@/utils/request";
import lodash from 'lodash';

export default {
  name: "videoIndex",
  head() {
    return {
      title: this.video.title ? this.video.title : '课程视频'
    }
  },
  data() {
    return {
      id: '',
      video: '',
      loading: false,
      title: '',
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "" //url地址
        }],
        // poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      videoActive: 0,
      activeNames: 0,
      chapters: []
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getVideos()
  },
  methods: {
    async getVideos() {
      this.loading = true
      try {
        let response = await authRequest('video/' + this.id, {
          method: 'GET'
        })
        this.video = response.data.data

        if (this.video.videos && this.video.videos.length > 0) {
          let chapters = []
          if (this.video.video_chapters && this.video.video_chapters.length > 0) {
            chapters = lodash.cloneDeep(this.video.video_chapters)
          } else {
            chapters.push({
              id: 0,
              title: '基础章',
              video_classes: this.video.videos
            })
          }
          this.videoActive = chapters[0].video_classes[0].id
          this.title = chapters[0].video_classes[0].title
          this.playerOptions.sources = [{
            type: 'video/mp4',
            src: chapters[0].video_classes[0].path
          }]
          this.chapters = chapters
        }

        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    changeVideo(videoIndex, index) {
      this.loading = true
      this.videoActive = this.chapters[index].video_classes[videoIndex].id
      this.title =  this.chapters[index].video_classes[videoIndex].title
      this.playerOptions.sources = [{
        type: 'video/mp4',
        src:  this.chapters[index].video_classes[videoIndex].path
      }]
      setTimeout(() => {
        this.loading = false
      }, 1500)
    },
    async playVideo() {
      try {
        const response = await authRequest('video/class/log', {
          method: 'POST',
          data: {
            id: this.videoActive
          }
        })
      } catch (e) {

      }
    },
    handleChange(e) {
      console.log(e)
    }
  }
}
</script>

<style scoped>
.video-box {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 15px;
}

.videos {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 15px;
}

.video-item {
  border: 1px dashed #ebebeb;
  margin-bottom: 10px;
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.video-item:hover {
  color: #2aacb2;
}

.video-item.current {
  color: #2aacb2;
}

.video-item-title {
  width: calc(100% - 30px);
}

.video-click {
  background-color: #2aacb2;
  color: #ffffff;
  font-size: 12px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
